export default __webpack_public_path__ + "public/assets/images/9d79a0bc89f17615a728c773980ce376.png";